import { InteriorIdUtils } from '@shared/utils/Instruments/InteriorIdUtils';
export class SearchHelper {
    constructor(FullName) {
        if (!isValidString(FullName)) {
            return;
        }
        const { instrumentTradableID, routeId, id, instrumentSpecificType } = InteriorIdUtils.parseInteriorID(FullName);
        this.InstrumentTradableID = instrumentTradableID;
        this.Route = routeId;
        this.Id = id;
        this.InstrumentSpecificType = instrumentSpecificType;
        this.FullName = InteriorIdUtils.removeInstrumentIdFromInteriorID(FullName, id, instrumentSpecificType);
    }
    GetInteriorID() {
        return this.FullName;
    }
}
